import React, { useEffect, useState } from 'react';
import InvestorDataChangeFormSC, {
  InvestorDataChangeFormErrorSC,
} from './investor-data-change-form.styled';
import { Formik } from 'formik';
import IbanFormSchema from './investor-data-change-form-rules';
import { HeadingTwo, SmallText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import Checkbox from '../../ui/checkbox/checkbox';
import { ReactComponent as CheckIcon } from '../../../assets/img/svg/profile/check.svg';

const InvestorDataChangeForm = ({ onSubmitForm, userData }) => {
  const [formInitialValues, setFormInitialValues] = useState({
    marketing_personal_data_consent: false,
    consent_to_the_processing_of_personal_data_after_termination_of_the_contract: false,
  });

  useEffect(() => {
    if (Object.keys(userData).length > 1) {
      setFormInitialValues({
        marketing_personal_data_consent: userData.marketing_personal_data_consent
          ? userData.marketing_personal_data_consent
          : false,
        consent_to_the_processing_of_personal_data_after_termination_of_the_contract: userData.consent_to_the_processing_of_personal_data_after_termination_of_the_contract
          ? userData.consent_to_the_processing_of_personal_data_after_termination_of_the_contract
          : false,
      });
    }
  }, [userData]);

  return (
    <InvestorDataChangeFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={IbanFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          const formattedValues = {
            marketing_personal_data_consent: values.marketing_personal_data_consent,
            consent_to_the_processing_of_personal_data_after_termination_of_the_contract:
              values.consent_to_the_processing_of_personal_data_after_termination_of_the_contract,
          };
          onSubmitForm(formattedValues);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
          const marketingPersonalDataHasError =
            errors &&
            errors.marketing_personal_data_consent &&
            touched.marketing_personal_data_consent;

          const consentProcessingHasError =
            errors &&
            errors.consent_to_the_processing_of_personal_data_after_termination_of_the_contract &&
            touched.consent_to_the_processing_of_personal_data_after_termination_of_the_contract;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="top-text-wrap">
                  <HeadingTwo className="bold">
                    <FormattedHTMLMessage
                      id="profile_agreements_change_form_title"
                      defaultMessage={dlt['profile_agreements_change_form_title']}
                    />
                  </HeadingTwo>
                </div>

                <div className="full-block-disabled">
                  <div className="check-wrap">
                    {userData.personal_data_consent ? <CheckIcon /> : null}
                  </div>
                  <div className="text-wrap">
                    <SmallText className="uppercase bold gray">
                      <FormattedHTMLMessage
                        id="profile_approvals_first_headline"
                        defaultMessage={dlt['profile_approvals_first_headline']}
                      />{' '}
                      <span className="required">
                        <FormattedHTMLMessage
                          id="profile_approvals_required"
                          defaultMessage={dlt['profile_approvals_required']}
                        />
                      </span>
                    </SmallText>
                  </div>
                </div>

                <div className="full-block">
                  <Checkbox
                    name="marketing_personal_data_consent"
                    hasError={marketingPersonalDataHasError}
                    value={`${values.marketing_personal_data_consent}`}
                    checked={values.marketing_personal_data_consent || false}
                    onChange={handleChange}
                    label="profile_approvals_second_headline"
                  />
                  {marketingPersonalDataHasError ? (
                    <InvestorDataChangeFormErrorSC>
                      {errors.marketing_personal_data_consent}
                    </InvestorDataChangeFormErrorSC>
                  ) : null}
                </div>
                <div className="full-block">
                  <Checkbox
                    name="consent_to_the_processing_of_personal_data_after_termination_of_the_contract"
                    hasError={consentProcessingHasError}
                    value={`${values.consent_to_the_processing_of_personal_data_after_termination_of_the_contract}`}
                    checked={
                      values.consent_to_the_processing_of_personal_data_after_termination_of_the_contract ||
                      false
                    }
                    onChange={handleChange}
                    label="profile_approvals_third_headline"
                  />
                  {consentProcessingHasError ? (
                    <InvestorDataChangeFormErrorSC>
                      {
                        errors.consent_to_the_processing_of_personal_data_after_termination_of_the_contract
                      }
                    </InvestorDataChangeFormErrorSC>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="full-block">
                  {/*    <BiggerText>
                    <FormattedMessage
                      id="requests_form_continue_hint"
                      defaultMessage={dlt['requests_form_continue_hint']}
                    />
                  </BiggerText> */}
                  <Button type="PRIMARY" className="form-submit" onClick={handleSubmit} withIcon>
                    <FormattedMessage
                      id="global_continue"
                      defaultMessage={dlt['global_continue']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </InvestorDataChangeFormSC>
  );
};

export default InvestorDataChangeForm;
